import { Box } from "@mui/material";

const clampPercent = (value) => {
    const numeric = Number(value);
    if (Number.isNaN(numeric)) return 0;
    if (numeric < 0) return 0;
    if (numeric > 100) return 100;
    return numeric;
};

// const hexToRgb = (hex) => {
//     const normalized = hex.replace('#', '');
//     const bigint = parseInt(normalized.length === 3
//         ? normalized.split('').map((c) => c + c).join('')
//         : normalized, 16);
//     const r = (bigint >> 16) & 255;
//     const g = (bigint >> 8) & 255;
//     const b = bigint & 255;
//     return { r, g, b };
// };

// const rgbToHex = ({ r, g, b }) => {
//     const toHex = (n) => n.toString(16).padStart(2, '0');
//     return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
// };

// const interpolateColor = (fromHex, toHex, t) => {
//     const from = hexToRgb(fromHex);
//     const to = hexToRgb(toHex);
//     const mix = (a, b) => Math.round(a + (b - a) * t);
//     return rgbToHex({ r: mix(from.r, to.r), g: mix(from.g, to.g), b: mix(from.b, to.b) });
// };

const ProgressBar = ({ progress = 0, color = '#00cc00', useGradient = false, gradientColours = ['#ff0000', '#0000ff'], trackColor = '#eeeeee' }) => {
    const percent = clampPercent(progress);

    return (
        <Box sx={{ width: '100%', backgroundColor: trackColor, borderRadius: '5px', my: 1 }}>
            <Box sx={{ overflow: 'hidden', width: `${percent}%` }}>
                <Box sx={{
                    width: `272px`,
                    height: 12,
                    borderRadius: '5px',
                    overflow: 'hidden',
                    backgroundColor: useGradient ? 'transparent' : color,
                    backgroundImage: useGradient
                        ? `linear-gradient(to right, ${gradientColours.join(', ')})`
                        : 'none',
                }}></Box>
            </Box>
        </Box>
    )
};

export default ProgressBar;